import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import * as apiGetUserSettingKey from 'api/userSetting/GetUserSettingKeyV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import { defaultSettingDto } from 'types/Setting/Setting';

export type CurrencyType = string;

export async function getCurrencyFromApi(): Promise<CurrencyType> {
	const userCurrency = await apiGetUserSettingKey.callApi('Price.Currency');
	const currency = await userCurrency.orElseAsync(async (): Promise<string> => {
		const settings = await apiGetSettingKey.callApi();
		return settings.getOrDefault(defaultSettingDto()).currencySettings.primaryCurrency;
	});

	return currency;
}

const rb = new ReducerBuilder<CurrencyType>();
export const currencyLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'Currency/LoadedFromBackend'
);

export const setReduxCurrency = rb.createActionForReducer(
	payloadReducer((x) => x),
	'Currency/SET'
);
export const currencyReducer = rb.createReducer();
